import { MessageCircle, FileText } from "lucide-react";
import { waLink } from "@/data/content";
import { scrollToId } from "@/lib/smooth";

export const MobileStickyBar = ({ waText }) => (
  <div
    className="fixed bottom-0 left-0 right-0 z-50 flex gap-2 border-t border-xmove-ink/10 bg-white p-3 md:hidden"
    data-testid="mobile-sticky-bar"
  >
    <button
      onClick={() => scrollToId("preventivo")}
      data-testid="sticky-preventivo-btn"
      className="flex flex-1 items-center justify-center gap-2 rounded-xl bg-xmove-orange py-3.5 text-sm font-bold text-white shadow-soft active:scale-[0.98] transition-transform"
    >
      <FileText size={16} />
      Preventivo Gratuito
    </button>
    <a
      href={waText || waLink("Salve XMOVE, vorrei un preventivo per il noleggio lungo termine.")}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="sticky-whatsapp-btn"
      className="flex flex-1 items-center justify-center gap-2 rounded-xl border-2 border-xmove-green py-3.5 text-sm font-bold text-xmove-green active:scale-[0.98] transition-transform"
    >
      <MessageCircle size={16} />
      WhatsApp
    </a>
  </div>
);
